export { default as "standard-plp" } from "./standard-plp.json";
export { default as "standard-plp-large-cards" } from "./standard-plp-large-cards.json";
export { default as "standard-plp-list-view" } from "./standard-plp-list-view.json";
export { default as "standard-plp-curated-categories" } from "./standard-plp-curated-categories.json";
export { default as "rvi-demo" } from "./rvi-demo.json";
export { default as "recs-demo" } from "./recs-demo.json";
export { default as "standard-plp-fullWidth-large" } from "./standard-plp-fullWidth-large.json";
export { default as "standard-plp-fullWidth-small" } from "./standard-plp-fullWidth-small.json";
